import { PagedRequest } from "../../models/paged.model";

export class UserSearchRequest extends PagedRequest{
    name?: string = undefined;
    email?: string = undefined;
}